<template>
  <span v-if="selectedMarketplace" class="chip badge badge-soft-secondary">
    <span :class="`flag-radius flag-icon flag-icon-${selectedMarketplace.value}`"></span>
    <span class="chip-text">{{ selectedMarketplace.text }} <strong>{{
        selectedMarketplace.value.toUpperCase()
      }}</strong></span>
  </span>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "MarketPlaceChip",
  props: {
    variant: {
      Default: 'info',
      type: String
    },
    marketPlaceId: {
      Default: null,
      type: String
    }
  },
  computed: {
    ...mapGetters('marketplaces', ['marketplaces'])
  },
  data() {
    return {
      selectedMarketplace: null,
    }
  },
  created() {
    const index = this.marketplaces.findIndex(item => item.marketplace_id === this.marketPlaceId)
    this.selectedMarketplace = this.marketplaces[index];
  }
}
</script>

<style scoped>
.chip {
  padding: 5px !important;
  font-size: 12px !important;
}

.chip-text {
  margin-left: 6px;
}
.flag-radius {
  border-radius: 2px;
}
</style>